import React from 'react';

/** Mount once inside the flow container so keyframes are not duplicated per edge (used by DraggableEdge). */
function FlowGlobalStyles() {
  return (
    <style>{`
      @keyframes flowAnimation {
        from {
          stroke-dashoffset: 12;
        }
        to {
          stroke-dashoffset: 0;
        }
      }
    `}</style>
  );
}

export default FlowGlobalStyles;
